export default __webpack_public_path__ + "static/contact-final-dc7f1d8858b9c2882972a549746c16da.gif";